
<div class="twofactor-wrapper  twofa-login">
  <div class="column__figure">

      <h2>Multi-Factor <br>
          Authentication</h2>
      <div class="figure__icon"><img src="assets/images/multifactor.svg" alt="Manage Your Account"></div>
      <p>Manage Your Account</p>
  </div>
  <div class="column__content">
      <img src="assets/images/logo.svg" class="logo" alt="Reflecx">
      <h3>Manage your account</h3>
      <h1>Recovery Code</h1>
    <div class="yellow-highlight">
        <div class="icon">
            <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="50" height="50" viewBox="0,0,256,256"
                style="fill:#e91e63;">
                <g fill="#e91e63" fill-rule="nonzero" stroke="none" stroke-width="1" stroke-linecap="butt"
                    stroke-linejoin="miter" stroke-miterlimit="10" stroke-dasharray="" stroke-dashoffset="0" font-family="none"
                    font-weight="none" font-size="none" text-anchor="none" style="mix-blend-mode: normal">
                    <g transform="scale(5.12,5.12)">
                        <path
                            d="M25,2c-12.6907,0 -23,10.3093 -23,23c0,12.69071 10.3093,23 23,23c12.69071,0 23,-10.30929 23,-23c0,-12.6907 -10.30929,-23 -23,-23zM25,4c11.60982,0 21,9.39018 21,21c0,11.60982 -9.39018,21 -21,21c-11.60982,0 -21,-9.39018 -21,-21c0,-11.60982 9.39018,-21 21,-21zM25,11c-1.65685,0 -3,1.34315 -3,3c0,1.65685 1.34315,3 3,3c1.65685,0 3,-1.34315 3,-3c0,-1.65685 -1.34315,-3 -3,-3zM21,21v2h1h1v13h-1h-1v2h1h1h4h1h1v-2h-1h-1v-15h-1h-4z">
                        </path>
                    </g>
                </g>
            </svg>
        </div>
        <p><strong>Put this code in safe place.</strong></p>
        <p>If you lose your device and don't have the recovery code you will lose access to your account.</p>
    </div>
      <div class="recovery-code-holder">
        <p>
            <span class="tf-red-highlight" style="margin-right: 10px;">{{code}}</span>
            <a data-tooltip="Copy To Clipboard" data-tooltip-conf="top"><i (click)="copyCode()" class="fa-regular fa-copy" style="margin-right: 3px;"></i></a>
            <a data-tooltip="Download PDF" data-tooltip-conf="top"><i (click)="downloadPDF()" class="fa-solid fa-download"></i></a>
        </p>
      </div>
      <div class="form-field">
          <button (click)="onContinue()">Continue</button>
      </div>
  </div>
</div>